const childRoutes = (prop) => [{
        path: 'test',
        name: prop + '.test',
        meta: { auth: true },
        component: () => import('../pages/Test.vue')
    },
    {
        path: 'service-process-list',
        name: prop + '.service_process_list',
        meta: { auth: true },
        component: () => import('../pages/service-process-list/List.vue')
    },
    {
        path: 'disbursing-officer-list',
        name: prop + '.disbursing_officer_list',
        meta: { auth: true },
        component: () => import('../pages/disbursing-officer-list/List.vue')
    },
    {
        path: 'institute-registration',
        name: prop + '.institute-registration',
        meta: { auth: true },
        component: () => import('../pages/institute-registration/List.vue')
    },
    {
        path: 'voluntary-organization',
        name: prop + '.voluntary-organization',
        meta: { auth: true },
        component: () => import('../pages/voluntary-organization/List.vue')
    },
    {
        path: 'payment',
        name: prop + '.payment',
        meta: { auth: true },
        component: () => import('../pages/payment/List.vue')
    },
    {
        path: 'service-list',
        name: prop + '.service-list',
        meta: { auth: true },
        component: () => import('../pages/service-list/List.vue')
    },
    {
        path: 'hospital-entry',
        name: prop + '.hospital-entry',
        meta: { auth: true },
        component: () => import('../pages/hospital-entry/List.vue')
    },
    {
        path: 'budget-approval-chain',
        name: prop + '.budget_approval_chain',
        meta: { auth: true },
        component: () => import('../pages/budget-approval-chain/List.vue')
    },
    {
        path: 'budget-approval-chain-add',
        name: prop + '.budget_approval_chain_add',
        meta: { auth: true },
        component: () => import('../pages/budget-approval-chain/Form.vue')
    },
    {
        path: 'application-form',
        name: prop + '.application-form',
        meta: { auth: true },
        component: () => import('../pages/application-form/List.vue')
    },
    {
        path: 'bank',
        name: prop + '.bank',
        meta: { auth: true },
        component: () => import('../pages/bank/List.vue')
    },
    {
        path: 'sdg',
        name: prop + '.sdg',
        meta: { auth: true },
        component: () => import('../pages/sdg/List.vue')
    },
    {
        path: 'sdg-service',
        name: prop + '.sdg_service',
        meta: { auth: true },
        component: () => import('../pages/sdg-service/List.vue')
    },
    {
        path: 'service-wise-budget',
        name: prop + '.service_wise_budget',
        meta: { auth: true },
        component: () => import('../pages/service-wise-budget/List.vue')
    },
    {
        path: 'national-level-institution',
        name: prop + '.national_level_institution',
        meta: { auth: true },
        component: () => import('../pages/national-level-institution/List.vue')
    },
    {
        path: 'coordination-level-council',
        name: prop + '.coordination_level_council',
        meta: { auth: true },
        component: () => import('../pages/coordination-level-council/List.vue')
    },
    {
        path: 'correction-of-offender-association',
        name: prop + '.correction_of_offender_association',
        meta: { auth: true },
        component: () => import('../pages/correction-of-offender-association/List.vue')
    },
    {
        path: 'criminal-rehabilitation-association',
        name: prop + '.criminal_rehabilitation_association',
        meta: { auth: true },
        component: () => import('../pages/criminal-rehabilitation-association/List.vue')
    },
    {
        path: 'notice-footer',
        name: prop + '.notice_footer',
        meta: { auth: true },
        component: () => import('../pages/notice-footer/List.vue')
    },
    {
        path: 'resident-entry-approve',
        name: prop + '.resident_entry_approve',
        meta: { auth: true },
        component: () => import('../pages/resident-entry-approve/List.vue')
    },
    {
        path: 'resident-entry-approve/:id?',
        name: prop + '.resident_entry_approve',
        meta: { auth: true },
        component: () => import('../pages/resident-entry-approve/Approve.vue')
    },
    {
        path: 'student-entry',
        name: prop + '.student_entry',
        meta: { auth: true },
        component: () => import('../pages/student-entry/List.vue')
    },
    {
        path: 'student-archive',
        name: prop + '.student_archive',
        meta: { auth: true },
        component: () => import('../pages/student-archive/List.vue')
    },
    {
        path: 'student-entry-archive',
        name: prop + '.student_entry_archive',
        meta: { auth: true },
        component: () => import('../pages/student-entry-archive/List.vue')
    },
    {
        path: 'import-student',
        name: prop + '.import_student',
        meta: { auth: true },
        component: () => import('../pages/import-student/List.vue')
    },
    {
        path: 'report-heading',
        name: prop + '.report_heading',
        meta: { auth: true },
        component: () => import('../pages/report-heading/List.vue')
    },
    {
        path: 'received-notifications',
        name: prop + '.received_notifications',
        meta: { auth: true },
        component: () => import('../pages/received-notifications/List.vue')
    },
    {
        path: 'cancer-kidney-budget',
        name: prop + '.cancer_kidney_budget',
        meta: { auth: true },
        component: () => import('../pages/cancer-kidney-budget/List.vue')
    },
    {
        path: 'installment',
        name: prop + '.installment',
        meta: { auth: true },
        component: () => import('../pages/installment-entry/List.vue')
    },
    {
        path: 'activity-log',
        name: prop + '.activity_log',
        meta: { auth: true },
        component: () => import('../pages/activity-log/List.vue')
    }
]
const routes = [{
    path: '/grant-allowance-service/configuration',
    name: 'grant_allowance_service.configuration',
    component: () => import('@/layouts/GrantAllowanceLayout.vue'),
    meta: { auth: true },
    children: childRoutes('grant_allowance_service.configuration')
}]
export default routes
